/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasOperation } from '../../openapi/models/OasOperation';
import { OasPathItem } from '../../openapi/models/OasPathItem';
import { ReplaceNodeCommand } from './ReplaceNodeCommand';

/**
 * A command used to replace an operation with a newer version.
 * @author eric.wittmann@gmail.com
 * @extends ReplaceNodeCommand
 * @class
 */
export class ReplaceOperationCommand extends ReplaceNodeCommand<OasOperation> {
    public _method : string;

    public _path : string;

    public constructor(old? : any, replacement? : any) {
        if(((old != null && old instanceof <any>OasOperation) || old === null) && ((replacement != null && replacement instanceof <any>OasOperation) || replacement === null)) {
            let __args = arguments;
            super(old, replacement);
            if(this._method===undefined) this._method = null;
            if(this._path===undefined) this._path = null;
            if(this._method===undefined) this._method = null;
            if(this._path===undefined) this._path = null;
            (() => {
                this._method = old.getMethod();
                this._path = (<OasPathItem>old.parent()).getPath();
            })();
        } else if(old === undefined && replacement === undefined) {
            let __args = arguments;
            super();
            if(this._method===undefined) this._method = null;
            if(this._path===undefined) this._path = null;
            if(this._method===undefined) this._method = null;
            if(this._path===undefined) this._path = null;
        } else throw new Error('invalid overload');
    }

    public removeNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_models_OasOperation(doc : Document, node : OasOperation) {
        let odoc : OasDocument = <OasDocument>doc;
        let path : OasPathItem = odoc.paths.getPathItem(this._path);
        NodeCompat.setProperty(path, node.getMethod(), null);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#removeNode(io.apicurio.datamodels.core.models.Document, io.apicurio.datamodels.core.models.Node)
     * @param {Document} doc
     * @param {OasOperation} node
     */
    public removeNode(doc? : any, node? : any) : any {
        if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null && node instanceof <any>OasOperation) || node === null)) {
            return <any>this.removeNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_models_OasOperation(doc, node);
        } else if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null) || node === null)) {
             throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); 
        } else throw new Error('invalid overload');
    }

    public addNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_models_OasOperation(doc : Document, node : OasOperation) {
        let odoc : OasDocument = <OasDocument>doc;
        let path : OasPathItem = odoc.paths.getPathItem(this._path);
        node._parent = path;
        node._ownerDocument = path.ownerDocument();
        NodeCompat.setProperty(path, node.getMethod(), node);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#addNode(io.apicurio.datamodels.core.models.Document, io.apicurio.datamodels.core.models.Node)
     * @param {Document} doc
     * @param {OasOperation} node
     */
    public addNode(doc? : any, node? : any) : any {
        if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null && node instanceof <any>OasOperation) || node === null)) {
            return <any>this.addNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_models_OasOperation(doc, node);
        } else if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null) || node === null)) {
             throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); 
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#readNode(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} doc
     * @param {*} node
     * @return {OasOperation}
     */
    readNode(doc : Document, node : any) : OasOperation {
        let odoc : OasDocument = <OasDocument>doc;
        let parent : OasPathItem = odoc.paths.getPathItem(this._path);
        let operation : OasOperation = parent.createOperation(this._method);
        Library.readNode(node, operation);
        return operation;
    }
}
ReplaceOperationCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ReplaceOperationCommand";
ReplaceOperationCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




